import { useEffect, useState } from "react";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-quill/dist/quill.snow.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL, request } from "../../../api/request.tsx";
import LoadingWrap from "../../../component/LoadingWrap.tsx";
import React from "react";
import { useLocation } from "react-router-dom";

const UpdatePopups = ({
  infoUpdate,
  setIsReload,
  isReload,
  handleCancel,
}: any) => {
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [isUpdate, setisUpdate] = useState(false);
  const location = useLocation();
  const { item } = location.state || {};

  useEffect(() => {
    if (item && item?.url) {
      setSelectedImage(item?.url);
      setisUpdate(true);
    }
  }, [item]);

  const handleImageChange = async (event: any) => {
    setLoading(true);
    setSelectedImage(URL.createObjectURL(event.target.files[0]));
    const formData = new FormData();
    formData.append("image", event.target.files[0]);

    try {
      const res = await fetch(`${BASE_URL}upload/upload`, {
        method: "POST",
        body: formData,
      });
      const resJson = await res.json();
      if (resJson?.success) {
        setSelectedImage(resJson?.data?.url);
      } else {
        notify(resJson?.isSuccess || "Đã có lỗi xảy ra, vui lòng thử lại sau");
      }
    } catch (e) {
      notify("Đã có lỗi xảy ra, vui lòng thử lại sau");
    }
    setLoading(false);
  };

  const notify = (title: string) => toast(title);

  const onUpdate = async () => {
    setLoading(true);
    if (selectedImage) {
      if (selectedImage)
        if (
          selectedImage?.includes("http://") ||
          selectedImage?.includes("https://")
        ) {
          const body = {
            url: selectedImage ? selectedImage : infoUpdate?.url,
            // type: infoUpdate?.type,
            id: infoUpdate?.id,
            // index: 1,
          };
          const res = await request(
            "banner/edit-home-popupbanner",
            body,
            "POST"
          );
          notify(res?.message || "Đã có lỗi xảy ra, vui lòng thử lại sau");
          setIsReload(!isReload);
          handleCancel();
        } else {
          alert("trống");
        }
    } else {
      notify("Vui lòng chọn hình ảnh");
    }
    setLoading(false);
  };

  const classInput =
    "w-full border-[1px] border-[pink] rounded-md px-2 py-2 outline-none";
  const classLable = "font-semibold text-[pink]";
  return (
    <div>
      <LoadingWrap active={loading}>
        <div className="w-full">
          <div className="text-2xl text-center text-[pink] font-bold">
            CẬP NHẬT POPUPS
          </div>

          <div className="mb-4">
            {selectedImage ? (
              <div className="mb-4">
                <div className={classLable}>Ảnh đã chọn: </div>
                <img
                  src={selectedImage?.replace(
                    "http://27.71.26.120",
                    "https://phototimevn.com"
                  )}
                  alt="Selected"
                  style={{ maxWidth: "100%" }}
                />
                <span
                  className="text-xs text-red-600 font-medium hover:underline cursor-pointer"
                  onClick={() => setSelectedImage(null)}
                >
                  Bỏ chọn
                </span>
              </div>
            ) : (
              <div className="mb-4">
                <div className={classLable}>Ảnh hiện tại: </div>
                <img
                  src={infoUpdate?.url}
                  alt="Selected"
                  style={{ maxWidth: "30%" }}
                />
              </div>
            )}
            <div className={classLable}>Tải ảnh: </div>
            <input
              onChange={handleImageChange}
              type="file"
              className={classInput}
            />
          </div>

          <div className="flex justify-center">
            <button
              onClick={onUpdate}
              color="primary"
              className="px-8 bg-[pink] text-white py-2 rounded-md self-center"
            >
              Cập nhập
            </button>
          </div>
        </div>
        <ToastContainer />
      </LoadingWrap>
    </div>
  );
};

export default UpdatePopups;
